/*eslint no-param-reassign: "error"*/
import dayjs from 'dayjs';
import { createSlice } from '@reduxjs/toolkit';
import min from 'lodash/min';

/**
 * get blackouts from timeslots
 * Blackouts has status euqals to 2
 * @param {array} blocks array of timeslots
 */
const getBlackouts = (blocks) => {
  return blocks.length > 0 ? blocks.filter((timeslot) => timeslot.timeslots.every((slot) => slot.status === 2)) : [];
}

/**
 * get availables blocks from blocks array.
 * @param {array} blocks array of blocks
 */
const getAvailableBlocks = (blocks) => {
  return blocks.length > 0 ? blocks.filter((timeslot) => timeslot.timeslots.some((slot) => slot.status === 1)) : [];
}

const concatSlots = (slots, newSlots) => {
  // Prevent duplicate values when concat
  const slotDates = new Set(newSlots.map(e => e.date))
  const filteredSlots = slots.filter(e => !slotDates.has(e.date))
  return [...new Set(filteredSlots.concat(newSlots) || [])]
};

const initialState = {
  data: [],
  frames: [],
  blackouts: [],
  finishBlackouts: [],
  timeslots: [],
  finishTimeslots: [],
  cachedParams: [],
  externalId: null,
  nextOccurrence: '',
  availableBlocks: [],
  finishAvailableBlocks: [],
  flattenTimeSlots: [],
  nonAvailableBlocks: [],
  finishNonAvailableBlocks: [],
  isFetchingBlocks: false,
  firstOccurrence: null,
  lastOccurrence: new Date(),
  loading: false,
  isRental: false,
  finishSelection: false,
};

const framesSlice = createSlice({
  name: 'frames',
  initialState,
  reducers: {
    fetchBlocksLoading(state, action) {
      state.isFetchingBlocks = action.payload;
    },
    fetchFrameLoading(state, action) {
      state.loading = action.payload;
    },
    resetFirstOccurrence(state) {
      state.firstOccurrence = dayjs();
    },
    setAvailableBlocks(state, action) {
      const { payload } = action;
      const blocks = getAvailableBlocks(payload.value);
      if (payload.isConcat) {
        state.availableBlocks = concatSlots(state.availableBlocks, blocks);
      } else {
        state.availableBlocks = blocks;
      }
    },
    setBlackouts(state, action) {
      const { payload } = action;
      const blackouts = getBlackouts(payload.value);
      if (payload.isConcat) {
        state.blackouts = concatSlots(state.blackouts, blackouts);
      } else {
        state.blackouts = blackouts;
      }
    },
    setFinishAvailableBlocks(state, action) {
      const { payload } = action;
      const blocks = getAvailableBlocks(payload.value);
      if (payload.isConcat) {
        state.finishAvailableBlocks = concatSlots(state.finishAvailableBlocks, blocks);
      } else {
        state.finishAvailableBlocks = blocks;
      }
    },
    setFinishBlackouts(state, action) {
      const { payload } = action;
      const blackouts = getBlackouts(payload.value);
      if (payload.isConcat) {
        state.finishBlackouts = concatSlots(state.finishBlackouts, blackouts);
      } else {
        state.finishBlackouts = blackouts;
      }
    },
    setFinishSelection(state, action) {
      state.finishSelection = action.payload;
    },
    setFinishTimeSlots(state, action) {
      const { payload } = action;
      if (payload.isConcat) {
        state.finishTimeslots = concatSlots(state.finishTimeslots, payload.value);
      } else {
        state.finishTimeslots = payload.value;
      }
    },
    setFrames(state, action) {
      const {
        frames, lastOccurrence, nextOccurrence, flattenTimeSlots,
      } = action.payload;
      if (!frames) return;

      state.frames = frames;
      state.flattenTimeSlots = flattenTimeSlots;
      state.nextOccurrence = nextOccurrence || state.nextOccurrence;
      state.firstOccurrence = state.firstOccurrence || min(frames.map((x) => dayjs(x.date)));
      state.lastOccurrence = lastOccurrence || state.lastOccurrence;
    },
    setFramesFrames(state, action) {
      state.frames = action.payload;
    },
    setGotPage(state, action) {
      state.cachedParams.push(action.payload);
    },
    setIsRentalFlag(state, action) {
      state.isRental = action.payload;
    },
    setTimeSlots(state, action) {
      const { payload } = action;
      if (payload.isConcat) {
        state.timeslots = concatSlots(state.timeslots, payload.value);
      } else {
        state.timeslots = payload.value;
      }
    },
    setTimeSlotsLoading(state, action) {
      state.isFetchingBlocks = action.payload;
    },
    setVariantSelected(state, action) {
      state.externalId = action.payload;
    },
  },
});

export const framesActions = framesSlice.actions;

export default framesSlice.reducer;